import { createElement } from "@wordpress/element";

/**
 * Internal dependencies
 */
import BaseButtonBlockAppender from '../button-block-appender';
import withClientId from './with-client-id';
export var ButtonBlockAppender = function ButtonBlockAppender(_ref) {
  var clientId = _ref.clientId;
  return createElement(BaseButtonBlockAppender, {
    rootClientId: clientId
  });
};
export default withClientId(ButtonBlockAppender);
//# sourceMappingURL=button-block-appender.js.map